<header class="tw-flex tw-justify-between tw-items-center tw-gap-4">
  <div class="tw-flex tw-items-center tw-gap-4 tw-overflow-auto">
    <ng-content select="[slot=start]"></ng-content>
    <h2 bitTypography="h3" noMargin class="tw-text-main tw-mb-0 tw-truncate" [attr.title]="title()">
      {{ title() }}
    </h2>
  </div>
  <button bitIconButton="bwi-close" type="button" bitDrawerClose [label]="'close' | i18n"></button>
</header>
